import { API_URL } from '../config';

// Helper function to get auth headers
const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
  };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  return headers;
};

// Helper function to handle API responses
const handleResponse = async (response) => {
  if (response.status === 401) {
    // Token expired or invalid, redirect to login
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    window.location.href = '/login';
    throw new Error('Authentication required');
  }
  
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.detail || errorData.error || 'Request failed');
  }
  
  return response.json();
};

// Helper function to create a system message based on context
const createSystemMessage = (context, data) => {
  const baseMessage = "You are an AI assistant helping analyze marketing mix modeling (MMM) data. Always answer in a very simple, non-technical, and business-friendly way. Keep your answers concise, to the point, and avoid technical jargon. Assume the user is a business leader with little technical background.";
  
  const contextMessages = {
    macro: "You are analyzing macro economic indicators including GDP, inflation, unemployment, consumer confidence, and sales index. ",
    seasonality: "You are analyzing seasonal patterns across different media channels (TV, Digital, Print, Radio, OOH). ",
    correlation: "You are analyzing correlations between different marketing channels and business metrics. ",
    attribution: "You are analyzing channel attribution and performance metrics including ROAS, spend, and impact. ",
    optimization: "You are analyzing budget optimization recommendations and expected outcomes. ",
    implementation: "You are analyzing implementation roadmap and success metrics. ",
    main: "You are analyzing overall MMM results and providing strategic insights. "
  };

  const dataContext = data ? `\nCurrent data context: ${JSON.stringify(data)}` : '';
  
  return baseMessage + (contextMessages[context] || contextMessages.main) + dataContext;
};

// Function to get response from ChatGPT through backend proxy
export const getChatGPTResponse = async (message, context, data) => {
  try {
    const systemMessage = createSystemMessage(context, data);

    // Log the payload for review
    const payload = {
      message,
      systemMessage,
      context,
      data
    };
    // console.log("Payload sent to ChatGPT API:", JSON.stringify(payload, null, 2));

    const response = await fetch(`${API_URL}/api/chat`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(payload)
    });

    const result = await handleResponse(response);
    return result.response;
  } catch (error) {
    console.error('Error getting AI response:', error);
    throw error;
  }
};

// Generic authenticated fetch function
export const authenticatedFetch = async (url, options = {}) => {
  const response = await fetch(url, {
    ...options,
    headers: {
      ...getAuthHeaders(),
      ...options.headers,
    },
  });
  
  return handleResponse(response);
}; 